import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../../../core/components/SearchComponent';

import lineModules from '../../../../core/components/lineModules'
import { Container } from './styles';
import { useSocket } from '../../../../../../hooks/Socket';
import { Button } from '../../../../core/components/Forms/Button/styles';

import sendPoster from './components/UpdateUnique';
import sendCorrection from './components/Update';
import printModule from './components/PrintModule';
import review from './components/Review';
import editPaper from '../../dashboardPages/CientificSubmission/modules/EditPaper';
import update from '../../dashboardPages/CientificSubmission/modules/Update';
import { FaImage } from 'react-icons/fa';
import { useConfiguration } from '../../../../../../hooks/Configuration';

interface ICreateModule {
  lineData: Record<string, any>;



}

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}

const MyPapersVisualization: React.FC = () => {

  const endpoint = `/list-my-avaliator-papers`;
  const { socket } = useSocket();
  const title = 'Trabalhos para avaliação';


  const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID' },
    project_id: { ref: 'project_id', column: 'project_id', label: 'Projeto', show: false },
    hash: { ref: 'hash', column: 'hash', label: 'Hash', show: false },
    selective_id: {
      ref: 'selective_id',
      column: 'selective_id_response',
      includeColumn: 'title',
      label: 'Projeto',
    },

    room: { ref: 'room', column: 'room', label: 'Sala' },
    section: { ref: 'section', column: 'section', label: 'Seção' },
    date: { ref: 'date', column: 'date', label: 'Data' },

    paper_id: {
      ref: 'paper_id',
      column: 'paper_id_response',
      includeColumn: 'title',
      label: 'Trabalho',
    },

    author: { ref: 'author', column: 'author', label: 'Autor' },
    orientator: { ref: 'orientator', column: 'orientator', label: 'Orientador' },


    category: { ref: 'category', column: 'category', label: 'Categoria' },
    area: { ref: 'area', column: 'area', label: 'Área' },
    subarea: { ref: 'subarea', column: 'subarea', label: 'SubÁrea', show: false },

    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date', show: false
    },
  };

  /*
   (lineData: Record<string, any>) =>
            update({
              lineData,
           
            }),
  
            */
  const endpoint2 = '/cientific_upload_poster';

  const formSchema = {

    presentation_image: {
      model: 'uploadImage',
      type: 'upload',
      name: 'presentation_image',
      label: 'Pôster (Max. 1mb)',

      endpoint: endpoint2,
    },

  };

  const formSchemaCorrection = {

    title: {
      model: 'input',
      name: 'title',
      label: 'Título',
      defaultValue: '',
    },
    short_description: {
      model: 'richText2',
      name: 'short_description',
      label: 'Resumo',
      defaultValue: '',
    },
    keywords: {
      model: 'jsonListMultiple',
      type: 'text',
      name: 'keywords',
      label: 'Palavras-chave',
      list: {
        title: { label: 'Palavra-chave', name: 'title' },

      },
    },

  };

  const config2: ISearchComponent = {
    idKey: endpoint,
    title: 'Trabalhos para avaliação',
    endpoint: endpoint,
    schema: schema,
    autoStart: true,
    showHeader: false,
    headModules: [],
    bodyModules: [
      (lineData: Record<string, any>) =>
        review({
          lineData,

        }),
      (lineData: Record<string, any>) =>
        printModule({
          lineData,

        }),

      /*   (lineData: Record<string, any>) =>
          sendPoster({
            lineData,
            title: 'Adicionar PDF do Pôster',
            formSchema: formSchema,
            validationSchema: {},
            endpoint: endpoint2,
            Icon: FaImage,
            moduleTitle: 'Adicionar PDF do Pôster'
          }), */


    ],

  };

  {/*, */ }

  return (
    <Container>

      <SearchComponent {...config2} />
    </Container>
  );
};

export default MyPapersVisualization;
